import React, { ReactNode, Component, createRef } from 'react';
import '../../styles/floating-footer.scss';

interface Props {
    className?: string;
    topId?: string;
    children?: ReactNode;
    mode?: 'hidden'|'fixed'|'static'|null;
}

interface State {
    mode: 'hidden'|'fixed'|'static';
}

export default class FloatingFooter extends Component<Props, State> {

    public static defaultProps: Partial<Props> = {
        className: '',
        mode: null,
    };

    public state: State = {
        mode: 'hidden',
    };

    protected interval: any;

    private ref = createRef<HTMLDivElement>();

    public componentDidMount() {
        window.addEventListener('scroll', this.handleMove);
        window.addEventListener('resize', this.handleMove);
        this.interval = window.setInterval(this.handleMove, 100);
    }

    public componentWillUnmount() {
        window.removeEventListener('scroll', this.handleMove);
        window.removeEventListener('resize', this.handleMove);
        window.clearInterval(this.interval);
    }

    private handleMove = () => {
        const {targetMode: mode} = this;
        if (this.state.mode !== mode) {
            this.setState({ mode });
        }
    }

    private get targetMode(): State['mode'] {
        return this.isHidden ? 'hidden'
                : this.isFixed ? 'fixed'
                : 'static';
    }

    private get isHidden() {
        const topElement = document.getElementById(this.props.topId);
        if (topElement) {
            const topRect = topElement.getBoundingClientRect();
            if (topRect.top >= 0) {
                return true;
            }
        }
        return false;
    }

    private get isFixed() {
        if (this.ref.current) {
            const bottomRect = this.ref.current.getBoundingClientRect();
            if (bottomRect.bottom > window.innerHeight) {
                return true;
            }
        }
        return false;
    }

    public componentWillReceiveProps(nextProps: Props) {
        if (
            nextProps.mode !== this.props.mode ||
            nextProps.topId !== this.props.topId
        ) {
            this.handleMove();
        }
    }

    public render() {
        const {children, className} = this.props;
        const mode = this.props.mode || this.state.mode;
        return <div
                className={`floating-footer ff-mode-${mode} ${className}`}>
            <div className="ff-inner">{children}</div>
            <div ref={this.ref} className="ff-lower" />
        </div>;
    }
}
